import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getMembershipImages } from '../../../api/memberships';

interface IUseMembershipImagesParams {
  organization_id?: string;
}

const useMembershipImages = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  params?: IUseMembershipImagesParams
) => {
  return useQuery({
    queryKey: ['membershipImages'],
    queryFn: () => getMembershipImages(params),
    ...options,
  });
};

export default useMembershipImages;
